import React, { Component } from 'react';
import InternalLink from 'components/views/internalLink/InternalLink';

import './footer.scss';

export default class Footer extends Component {

    render() {
        return (
            <div className={`page-footer`}>
                <div className="page-footer-copyright">
                    &copy; ActiDoo GmbH {new Date().getFullYear()}
                </div>
            </div>
        );
        
        /*
            <div className="page-footer-navigation">
                <InternalLink to={`impress`}>Impressum</InternalLink>
            </div>
        */
    }
}



// WEBPACK FOOTER //
// ./src/components/views/footer/Footer.js